import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=2c6a9081&scoped=true&"
import script from "./NewMessage.vue?vue&type=script&lang=js&"
export * from "./NewMessage.vue?vue&type=script&lang=js&"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=2c6a9081&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a9081",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c6a9081')) {
      api.createRecord('2c6a9081', component.options)
    } else {
      api.reload('2c6a9081', component.options)
    }
    module.hot.accept("./NewMessage.vue?vue&type=template&id=2c6a9081&scoped=true&", function () {
      api.rerender('2c6a9081', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NewMessage.vue"
export default component.exports